import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';

interface TwoFactorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  onBack: () => void;
}

export const TwoFactorModal: React.FC<TwoFactorModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  onBack,
}) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // TODO: Implement 2FA verification API call
    setTimeout(() => {
      setLoading(false);
      onSuccess();
    }, 1000);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Login" size="sm">
      <div className="space-y-4">
        <div className="bg-blue-50 p-4 rounded-lg text-sm text-blue-900">
          Enter the 6-digit code from Google or Microsoft Authenticator.
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Enter 2FA Code"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Value"
            maxLength={6}
            required
          />

          <div className="flex space-x-3">
            <Button type="button" variant="secondary" onClick={onBack} fullWidth>
              Back to Login
            </Button>
            <Button type="submit" fullWidth disabled={loading}>
              {loading ? 'Verifying...' : 'Verify'}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
